document.addEventListener('DOMContentLoaded', () => {
  // Nur auf Geräten mit echter Hover-Fähigkeit aktivieren (Desktop/Maus)
  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!canHover) return;

  const detailsList = document.querySelectorAll('header-menu details.mega-menu');
  detailsList.forEach((details) => {
    let closeTimer = null;

    const open = () => {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      details.setAttribute('open', '');
    };

    const close = (delay = 160) => {
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        details.removeAttribute('open');
      }, delay);
    };

    // Hover öffnet/schließt
    details.addEventListener('mouseenter', open);
    details.addEventListener('mouseleave', () => close(160));

    // Optional: Zusammen mit Klick auch stabil
    const summary = details.querySelector('summary');
    if (summary) {
      // Pfeiltaste/ESC Barrierefreiheit
      details.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close(0);
      });
      // Klick soll weiterhin funktionieren; kein preventDefault nötig
    }
  });
});
document.addEventListener('click', (e) => {
  if (e.target.closest('.header__menu-item[href="#"]')) e.preventDefault();
});
